import { render, staticRenderFns } from "./WechatEvaluateIndex.vue?vue&type=template&id=7aa85b92&scoped=true"
import script from "./WechatEvaluateIndex.vue?vue&type=script&lang=js"
export * from "./WechatEvaluateIndex.vue?vue&type=script&lang=js"
import style0 from "./WechatEvaluateIndex.vue?vue&type=style&index=0&id=7aa85b92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa85b92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa85b92')) {
      api.createRecord('7aa85b92', component.options)
    } else {
      api.reload('7aa85b92', component.options)
    }
    module.hot.accept("./WechatEvaluateIndex.vue?vue&type=template&id=7aa85b92&scoped=true", function () {
      api.rerender('7aa85b92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/evaluate/WechatEvaluateIndex.vue"
export default component.exports